(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1817],{

/***/ 18690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./action-1.png": 17488,
	"./action-2.png": 71940,
	"./action-3.png": 14930,
	"./action-4.png": 49347,
	"./action-5.png": 57975,
	"./action-6.png": 60217,
	"./action-7.png": 43105,
	"./action-8.png": 7466,
	"./action-9.png": 92130,
	"./bolosign-faded-logo.png": 85698,
	"./james.jpg": 31198,
	"./landing-page.png": 26386,
	"./lisa.jpg": 88466,
	"./sarah.jpg": 83801,
	"./stars.png": 76643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18690;

/***/ }),

/***/ 7314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Minus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M5 12h14", key: "1ays0h" }]];
const Minus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("minus", __iconNode);


//# sourceMappingURL=minus.js.map


/***/ }),

/***/ 31012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Plus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
const Plus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("plus", __iconNode);


//# sourceMappingURL=plus.js.map


/***/ }),

/***/ 17488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/action-1.b98dfcf0.png","height":750,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEXv7eza2dff5u/R0ND5+Pa8wMTV1NTg397Hx8ry8/PGxdyrq6z//v6usLORkqfAw8eanKCyseHj4tu0woHLAAAAAXRSTlP5hIeS3gAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAD1JREFUeJwVxsURwDAQBLA9JtuB/ovNRC8BOTOiAO19nxMKyVWcb0GMhPoB3CKiG/CsWhkKv6r0DxkzW+gHQvkBvUkC5uMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 71940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/action-2.071e9c3e.png","height":750,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEXi5OTv8O3+/v76+Pbz8vDIx8i/v8Dp6+q4ubvb2tvFxcasrbCdnqHR0NG3XhCeAAAAAnRSTlP+/T+gj6oAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAxSURBVHicVcbJEQAgCASw5RIQ7L9dh5/mFZBkdQdAdFZFGBxJyrmhEs6MyZrYF8ibCzCdASQhuNUJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 14930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/action-3.ee66a1cf.png","height":750,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEXw7/D39vb8/f27u729vsCtra61triZmp/n5uVPbFJoAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADJJREFUeJw9ikEKACAMw9JuU///YtkEDymhBM6qqgOKtXeGUGA7+gHNfMkOc7CfyHZyARkZAJU8R1IGAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 49347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/action-4.f8121dd5.png","height":750,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEXm5ubExMidnaHi4OHx8PGvr7LX19jv7ez39fTCwsPQ0NKmp6rHx8b5+fy9vb6wsMje3tytrOK9vOJdGHToAAAACHRSTlP+/////////KYiA/AAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA9SURBVHicHcpJEoAgDADBIWQFEfX/j7X01ocmckyRE5I5xeQguxHaisTc+4duftGKANU1Cl2pz73/PNyrvTa7AZ+dAL4+AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 57975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/action-5.23fdee24.png","height":750,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEXx8O/h4OD9/Prp6ej19fS2t7m/v8HExMXEw8WPkZVtcHaNj5MPAIaHAAAAAXRSTlP89O1mUQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADRJREFUeJw1xkESgCAQA8HJJqwI//+vpRZ9asC2AXqv+506jgQaIZqFRjnqk+tL6k8ozXoAG7UAxNjkrsUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 60217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/action-6.00f5efb9.png","height":750,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEXx8O7+/v77+PatrbDg4uS6u762uLvY19ibnJ/p6erHxcaXmJv7v28MAAAAAXRSTlP9g+pWxwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADJJREFUeJwtyEEOACAIA7DBJqD+/78Gw60pIFZRgJN1ycbJzEZoC/FhZgvwJQz2TKQ3HiJIANwwvCo4AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 43105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/action-7.96bc8406.png","height":750,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAATlBMVEXz8+7r6ef6+vusrLe1trjt7+TEpf2lp6bn5+P///6PVP6eoKCRkpmugP+3usPZ2Napd/6AZLmNeLqajLnp6erazeeVYPyqorfz5/+IcLyVeeXhAAAACHRSTlP7/////////gDMbLgAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABBSURBVHicJcZXEoAwCAXAFwmEkF4s9z+p47hfC7SQUmiAo5pzJUBnKb1PBg+7zAZDl4jIYig98YjeQe9T/3jsLy9XHwJMihSxBAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/action-8.8932edfd.png","height":750,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEXw8PDCwsPBwcHp6Oa2t7n19fr5+f6ysrWlp6qIipCFiI7HO4sNAAAAA3RSTlP9/v6XUDd1AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAMklEQVR4nD3JQQoAIQwEwdbJJFn//2ARZW8FBRoRU0D1t7pB5Uy3UIBdB8L5I15dKA82JLoBAGNXNEgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 92130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/action-9.f8989bb3.png","height":750,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEX29PK5ubv+/v/6+ffj4+Pt7Oqys7WnqKuen6KP3DBEAAAAAXRSTlP3Yz+/2QAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAACxJREFUeJx1xrkRADAIAzA/YNh/4lzSR5WAyuwUYGaHuSlJ6RtbfJG+aZt9AB78AMm1P5irAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 85698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/bolosign-faded-logo.5e050f21.png","height":355,"width":355,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEXVwvzYxf7BtffYxf/v2f9MaXHXxP7Zxf7bx/7gy//YxP/Wx//Zxf/m0P7Ww/vVw//u1/3eyv/iAy8zAAAAEXRSTlMf7RSU/QBW3Z7h+Thz9kVvvDRjm78AAAAJcEhZcwAACxMAAAsTAQCanBgAAAA6SURBVHicBcGJAcAgDAOxAxLsQD/2X7YSyZBMgmZFCHy4Rguj1WEfUat/0VU4nj05hrrfWQWJWzP5AzXFAYy1LA8rAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 31198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/james.5c0e1db6.jpg","height":133,"width":200,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAfEAABBAAHAAAAAAAAAAAAAAADAAECBAUREiEiUbH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABURAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIRAxEAPwCt7FyjrWZGHA5a8hQacs+Wrd3dve0RFAit/9k=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 26386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/landing-page.a21a578c.png","height":464,"width":530,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAS1BMVEVMaXE8PErXv/6jW/9JRUqikMnX2uDk5ebJystydH2PUv9zUbKbZv+ljtJzSMiXhbrErumJiIuQko99b5yhj7729/aen5/q6e3jx/+x/qlIAAAAFXRSTlMAJP0OL/D9/v5PgnG2zqXj/P7inrco9mJ+AAAACXBIWXMAABJ0AAASdAHeZh94AAAAPUlEQVR4nBXGSRKAMAgEwMlCALdodIj/f6llnxpIXURuAPXM+X3+KC1GAmpjXOEoa5tGOpZDaaqObVcap39ARAJYq1CgLwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 88466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/lisa.6c0a3c16.jpg","height":133,"width":200,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAACAgIDAQAAAAAAAAAAAAABAgAEAxEFISKh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAT/xAAaEQABBQEAAAAAAAAAAAAAAAAAAQIREyEx/9oADAMBAAIRAxEAPwCapUkHFOSdtltLiLAaOmV/nkdRERW2Ewm6f//Z","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 83801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/sarah.faaab8c7.jpg","height":133,"width":200,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAABBQADAAAAAAAAAAAAAAAAAQIEERIFMWH/xAAVAQEBAAAAAAAAAAAAAAAAAAAEBv/EABsRAAEEAwAAAAAAAAAAAAAAAAEAAgMSBTFx/9oADAMBAAIRAxEAPwCzdxbHRXyNoipH3WferAA2Ak26orLxsYYqjbQv/9k=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 76643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/stars.9cd635f4.png","height":40,"width":150,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAABlBMVEXYtmHZuGSjjMURAAAAAnRSTlMxOwHFI64AAAAJcEhZcwAACxMAAAsTAQCanBgAAAASSURBVHicY2BgBAMGCGBkYAAAAGYACHiPRXMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 33376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);




const legals = [
    {
        name: "ESIGN Act",
        image: "esign.png",
        fullForm: "Electronic Signatures in Global and National Commerce Act (ESIGN)",
        description: "We ensure every electronic signature on our platform is legally binding by verifying the signer's identity and capturing their intent to sign."
    },
    {
        name: "UECA Act",
        image: "ueca-act.png",
        fullForm: "Uniform Electronic Communications Act (UECA)",
        description: "BoloSign's robust record-keeping and verification processes ensure that any electronic records related to environmental covenants are legally valid and enforceable."
    },
    {
        name: "Federal Decree Law",
        image: "federal-decree-law.png",
        fullForm: "Federal Decree-Law No. 46 of 2021 (UAE)",
        description: "We adhere to this law by implementing robust security measures and ensuring that all electronic transactions are legally binding and recognized by UAE authorities."
    },
    {
        name: "UETA Act",
        image: "ueta.png",
        fullForm: "The Uniform Electronic Transactions Act (UETA)",
        description: "BoloSign ensures clear consent from all parties to conduct business electronically, and our platform maintains robust records to validate each transaction."
    },
    {
        name: "ETL Act",
        image: "etl-act.png",
        fullForm: "Electronic Transactions Law (ETL)",
        description: "BoloSign adheres to the specific ETLs of each country where we operate, ensuring that electronic signatures are legally valid and compliant with local regulations."
    },
    {
        name: "HIPAA",
        image: "hipaa2.png",
        fullForm: "Health Insurance Portability and Accountability Act (HIPAA)",
        description: "We implement stringent administrative, physical, and technical safeguards to protect electronic protected health information (ePHI) ensuring data confidentiality, integrity, and availability. "
    },
    {
        name: "PIPEDA Act",
        image: "pipeda-act.png",
        fullForm: "Personal Information Protection and Electronic Documents Act (PIPEDA)",
        description: "Our platform adheres to PIPEDA guidelines, ensuring that your data is protected and only used for its intended purpose."
    },
    {
        name: "EIDAS Act",
        image: "eidas.png",
        fullForm: "eIDAS (European Union)",
        description: "We comply with eIDAS by offering advanced electronic signatures that meet EU standards. Our platform ensures secure and legally binding transactions across all EU member states."
    },
    {
        name: "SOC 2 Type II",
        image: "soc2.png",
        fullForm: "SOC 2 (Service Organization Control 2)",
        description: "We adhere to SOC 2 criteria by implementing robust security measures, ensuring system availability, and maintaining data integrity. Our platform undergoes regular SOC 2 audits to verify that our controls are effective and meet industry standards. "
    },
    {
        name: "CCLA Act",
        image: "ccla-act.png",
        fullForm: "Contract and Commercial Law Act 2017 (CCLA)",
        description: "We provide transparent privacy policies and give users control over their personal data. Our platform allows users to opt out of the sale of their personal information, in compliance with CCLA."
    },
    {
        name: "ETA Act",
        image: "eta-act.png",
        fullForm: "Electronic Transactions Act 1999 (ETA)",
        description: "We align with the ETA by ensuring that electronic signatures on our platform are legally binding and that all electronic records are securely stored and easily accessible."
    },
    {
        name: "SOC Type 1",
        image: "soc1.png",
        fullForm: "SOC 1 (Service Organization Control 1)",
        description: "We undergo regular SOC 1 audits to demonstrate our commitment to secure and reliable financial reporting. Our internal controls are designed to protect client data and ensure the accuracy of financial transactions. "
    },
    {
        name: "GDPR",
        image: "gdpr.png",
        fullForm: "General Data Protection Regulation (GDPR)",
        description: "BoloSign ensures lawful, fair, and transparent data processing by obtaining explicit consent from users before collecting their data."
    },
    {
        name: "CCPA",
        image: "ccpa.png",
        fullForm: "California Consumer Privacy Act (CCPA)",
        description: "We provide a transparent privacy policy that informs users about their data rights under the CCPA. Our platform allows users to access and delete their personal information easily. "
    },
    {
        name: "ISO 27001",
        image: "iso.png",
        fullForm: "ISO (International Organization for Standardization)",
        description: "We follow ISO 27001 guidelines to establish, implement, maintain, and continually improve our information security management system (ISMS). "
    }
];
const Legal = (param)=>{
    let { bgColor ="bg-accent-blue" , shadow =true , complianceGroupImage =true  } = param;
    const [showLaws, setShowLaws] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showLawDescription, setShowLawDescription] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col sm:flex-row gap-6",
            children: [
                complianceGroupImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "shrink-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/ltd/legal-hero.png"),
                        alt: "Legal",
                        width: 120,
                        height: 120,
                        className: "w-[96px] sm:w-[120px] object-contain"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "sm:grow sm:w-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-2xl sm:text-3xl font-semibold text-gray-900",
                            children: "How does BoloSign’s legal compliance compare to industry leaders like DocuSign?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-5 text-gray-700 leading-relaxed",
                            children: "BoloSign fully complies with all major e-signature regulations, including the ESIGN Act, UETA, PIPEDA, UECA, ETA, and CCLA. Our platform adheres to the same rigorous legal standards as industry leaders, ensuring documents signed through BoloSign maintain full legal validity across jurisdictions."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 ".concat(showLaws ? "grid" : "hidden sm:grid"),
                            children: legals.map((legal)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative group bg-surface border border-surface-dark p-4 cursor-default rounded-md hover:cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    src: legal.local ? legal.image : "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/security/").concat(legal.image),
                                                    alt: legal.name,
                                                    width: 40,
                                                    height: 40,
                                                    className: "w-10 h-10 object-contain"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-gray-900 font-medium",
                                                    children: legal.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute z-20 top-full left-0 mt-2 w-full rounded-lg bg-surface-dark text-gray-900 p-4 text-sm hidden group-hover:block transition-opacity duration-300 shadow-md ",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "font-semibold",
                                                        children: [
                                                            legal.fullForm,
                                                            ":"
                                                        ]
                                                    }),
                                                    " ",
                                                    legal.description
                                                ]
                                            })
                                        })
                                    ]
                                }, legal.name))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-center sm:hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: ()=>setShowLaws((prev)=>!prev),
                                className: "mt-6 px-6 py-3 bg-black text-white font-medium rounded-md",
                                children: showLaws ? "Hide All Laws" : "Show All Laws"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Legal);


/***/ }),

/***/ 59183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46687);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71631);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69274);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);









const CtaOne = (param)=>{
    let { heading1 , heading2 , heading3 , paragraph , paragraphStyling , buttonsStyling , buttonPrimaryText , buttonPrimaryUrl , buttonPrimaryIcon , buttonPrimaryBorderShadow , buttonPrimaryNewTab , buttonPrimaryBg , buttonSecondaryText , buttonSecondaryUrl , buttonSecondaryIcon , buttonSecondaryNewTab , signaturePopupOpen  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        open: false,
        mode: "register"
    });
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const isSignaturePage = signaturePopupOpen;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .is1DollarTrialCampaign */ .Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-7 sm:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPopupOpen: signaturePopup.open && isSignaturePage,
                mode: signaturePopup.mode,
                setIsPopupOpen: (value)=>setSignaturePopup((prev)=>({
                            ...prev,
                            open: value
                        })),
                setMode: (mode)=>setSignaturePopup((prev)=>({
                            ...prev,
                            mode: mode
                        }))
            }),
            heading1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl",
                children: heading2
            }),
            heading3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "font-bold text-2xl sm:text-3xl",
                children: heading3
            }),
            paragraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg sm:text-xl ".concat(paragraphStyling),
                children: paragraph
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ".concat(buttonsStyling && buttonsStyling),
                children: [
                    buttonPrimaryText && (isSignaturePage ? is1DollarTrialCampaignState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .Button1 */ .g, {
                        btnText: buttonPrimaryText,
                        bgColor: buttonPrimaryBg || "bg-violet-500",
                        textColor: "text-white",
                        border: "border border-violet-500 ",
                        showLoading: false,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {}),
                        borderShadow: buttonPrimaryBorderShadow !== null && buttonPrimaryBorderShadow !== void 0 ? buttonPrimaryBorderShadow : true,
                        px: "px-5"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimaryDiv */ .gf, {
                        buttonText: buttonPrimaryText,
                        onclick: ()=>setSignaturePopup((prev)=>({
                                    ...prev,
                                    open: true
                                })),
                        buttonUrl: buttonPrimaryUrl,
                        icon: buttonPrimaryIcon,
                        borderShadow: buttonPrimaryBorderShadow,
                        newTab: buttonPrimaryNewTab,
                        bgColor: buttonPrimaryBg
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary */ .IS, {
                        buttonText: buttonPrimaryText,
                        buttonUrl: buttonPrimaryUrl,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {})
                    })),
                    buttonSecondaryText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonSecondaryBorder */ .AL, {
                        buttonText: buttonSecondaryText,
                        buttonUrl: buttonSecondaryUrl
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CtaOne);


/***/ }),

/***/ 86585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const FaqCard = (param)=>{
    let { faqQuestion , faqAnswer , questionStyling , answerStyling  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: ()=>setIsOpen(!isOpen),
        className: "px-8 py-7 transition-all duration-300 border border-surface-dark rounded-2xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: faqQuestion
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: faqAnswer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqCard);


/***/ }),

/***/ 22288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59183);
/* harmony import */ var _components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86585);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43138);
/* harmony import */ var components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74791);







const faqData = [
    {
        question: "How many signatures can I take?",
        answer: "\n      <p>We offer a range of plans designed to suit different needs. Each plan comes with a generous signature quota to ensure you can request as many signatures as you need.</p>\n      <p>If you ever find your usage increasing, you can seamlessly upgrade to a higher plan at any time—no interruptions or hidden fees.</p>\n      <p>Our goal is to grow with you, so you’ll always have enough signatures to keep your documents moving.</p>\n    "
    },
    {
        question: "Does the recipient need a Google Account?",
        answer: "\n      <p>Not at all! We’ve made BoloSign as accessible as possible. Your recipients can open, review, and sign documents using any standard email address.</p>\n      <p>They do not need a Google Account (or any other specific provider) to sign. We believe in keeping the signing process hassle-free for everyone involved.</p>\n    "
    },
    {
        question: "What will happen if I run out of signature quota?",
        answer: "\n      <p>We understand that business needs can change quickly. If you reach your signature limit, you’ll have the option to top up with additional signatures or upgrade to a higher plan.</p>\n      <p>We’ll also send you friendly reminders when you’re approaching your limit so you’re never caught off guard.</p>\n    "
    },
    {
        question: "What will happen to my data if I cancel my subscription?",
        answer: "\n      <p>Your data remains safe and accessible even if you decide to cancel.</p>\n      <p>We’ll keep your documents stored securely for a grace period (as outlined in our data retention policy), giving you ample time to download or back up anything you need.</p>\n      <p>Should you decide to re-subscribe later, your documents will be right where you left them.</p>\n    "
    },
    // {
    //   question: "Fair Usage Policy",
    //   answer: `
    //     <div class="flex flex-col gap-2">
    //     <p>If you're reading this, you're not a small business anymore—congratulations on your success! While our unlimited plans are specifically designed for small businesses (typically between 1-25 employees), small businesses usually operate comfortably within the following limits:</p>
    //     <ul class="list-disc pl-8">
    //       <li>Up to 1200 PDFs per year</li>
    //       <li>Up to 1200 Forms per year</li>
    //       <li>Up to 12,000 Form Responses per year</li>
    //       <li>Up to 1200 PDF Templates per year</li>
    //     </ul>
    //     <p>We also offer tailored solutions for medium and large businesses, maintaining our commitment to being at least 10 times more affordable than providers like DocuSign or PandaDoc.</p>
    //     <p>If you want details on pricing tailored to your company's size or if you're unsure whether your usage fits within our fair use guidelines, please contact us directly at <a href="mailto:support@boloforms.com" class="text-violet-600 underline">support@boloforms.com</a>.</p>
    //     </div>
    //   `,
    // },
    {
        question: "How can I contact support?",
        answer: '\n      <p>We’re always here to help. You can reach our friendly support team via:</p>\n      <ul class="list-disc pl-5">\n      <li><strong>POC:</strong> You can always contact your assigned POC.</li>\n     <li><strong>Phone:</strong> <a href="tel:+14156496611" class="text-blue-500">+1 (415) 649-6611</a></li>\n      <li><strong>Email:</strong> <a href="mailto:support@boloforms.com" class="text-blue-500">support@boloforms.com</a></li>\n        <li><strong>Live Chat:</strong> Available on our website during business hours</li>\n        <li><strong>Help Center:</strong> Check out our knowledge base for quick tips and tutorials</li>\n      </ul>\n      <p>We aim to respond to all inquiries as swiftly as possible, ensuring you get the assistance you need right when you need it.</p>\n    '
    },
    {
        question: "Can I add team members or manage multiple users under one account?",
        answer: '\n      <p>Yes! We understand the importance of collaboration. BoloSign offers multi-user plans that allow you to:</p>\n      <ul class="list-disc pl-5">\n        <li>Add team members</li>\n        <li>Set permissions</li>\n        <li>Manage all user activities under a single workspace</li>\n      </ul>\n      <p>This centralized approach helps you keep track of documents, signatures, and billing with ease.</p>\n      <p>Plus, you can assign different roles or permissions, ensuring everyone has access to exactly what they need.</p>\n      <p>If you have a larger team or specific requirements, our sales team is happy to discuss custom solutions tailored to your organization.</p>\n    '
    }
];
const FAQ = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        faqData: faqData,
        heading: "Our Product and Features FAQs",
        description: "We're dedicated to delivering exceptional results, fostering lasting relationships, and ensuring our clients' success in an ever competitive digital marketplace."
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ);


/***/ })

}]);